import { baseApi } from "./baseApi";

const installationApi: any = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getInstallations: builder.query({
      query: (params) => {
        let url = "installations";

        url += "?";

        if (params.page) {
          url += `page=${params.page}&`;
        }
        if (params.page_size) {
          url += `page_size=${params.page_size}&`;
        }

        if (params.status) {
          url += `status=${params.status}&`;
        }
        if (params.brand_id) {
          url += `brand_id=${params.brand_id}&`;
        }
        if (params.city_id) {
          url += `city_id=${params.city_id}&`;
        }
        if (params.contact_number) {
          url += `contact_number=${params.contact_number}&`;
        }
        if (params.customer_name) {
          url += `customer_name=${params.customer_name}&`;
        }
        if (params.assigned_city_manager_id) {
          url += `assigned_city_manager_id=${params.assigned_city_manager_id}&`;
        }
        if (params.zone_id) {
          url += `zone_id=${params.zone_id}&`;
        }
        if (params.partner_id) {
          url += `partner_id=${params.partner_id}&`;
        }
        if (params.agent_id) {
          url += `agent_id=${params.agent_id}&`;
        }
        if (params.brand_booking_code) {
          url += `brand_booking_code=${params.brand_booking_code}&`;
        }
        if (params.brand_booking_status) {
          url += `brand_booking_status=${params.brand_booking_status}&`;
        }
        if (params.ecb_code) {
          url += `ecb_code=${params.ecb_code}&`;
        }
        if (params.start_date) {
          url += `start_date=${params.start_date}&`;
        }
        if (params.end_date) {
          url += `end_date=${params.end_date}&`;
        }
        if (params.next_follow_up_start) {
          url += `next_follow_up_start=${params.next_follow_up_start}&`;
        }
        if (params.next_follow_up_end) {
          url += `next_follow_up_end=${params.next_follow_up_end}&`;
        }
        if (params.install_type) {
          url += `install_type=${params.install_type}&`;
        }
        if (params.start_approved_at) {
          url += `start_approved_at=${params.start_approved_at}&`;
        }
        if (params.end_approved_at) {
          url += `end_approved_at=${params.end_approved_at}&`;
        }
        if (params.state_id) {
          url += `state_id=${params.state_id}&`;
        }
        if (params.unassigned) {
          url += "unassigned=true&";
        }

        if (params.unassigned === false) {
          url += "unassigned=false&";
        }

        if (params.payment_received) {
          url += "payment_received=true&";
        }
        if (params.payment_received === false) {
          url += "payment_received=false&";
        }

        // Remove the trailing '&' if any
        if (url.endsWith("&")) {
          url = url.slice(0, -1);
        }

        // Remove the trailing '?' if any
        if (url.endsWith("?")) {
          url = url.slice(0, -1);
        }
        return url;
      }
    }),
    getInstallationById: builder.query({
      query: (id) => `installations/${id}`
    }),
    createInstallation: builder.mutation({
      query: (data) => ({
        url: "installations",
        method: "POST",
        body: data
      })
    }),
    updateInstallation: builder.mutation({
      query: (data) => ({
        url: `installations/${data?.id}`,
        method: "PUT",
        body: data
      })
    }),
    // {{Server}}/api/v1/installations/84/cancel?reason=CustomerRefused
    cancelInstallation: builder.mutation({
      query: (data) => ({
        url: `installations/${data?.id}/cancel?reason=${data?.reason}`,
        method: "PUT"
      })
    }),
    // {{Server}}/api/v1/installations/84/on_hold?reason=DealerRequest
    onHoldInstallation: builder.mutation({
      query: (data) => ({
        url: `installations/${data?.id}/on_hold?reason=${data?.reason}`,
        method: "PUT"
      })
    }),
    deleteInstallation: builder.mutation({
      query: (id) => ({
        url: `installations/${id}`,
        method: "DELETE"
      })
    }),
    createCustomerConnectLogForInstallation: builder.mutation({
      query: (data) => ({
        url: `installations/${data?.id}/add_customer_connect_log`,
        method: "POST",
        body: data
      })
    }),
    updateCustomerConnectLogForInstallation: builder.mutation({
      query: (data) => ({
        url: `installations/${data?.id}/edit_customer_connect_log`,
        method: "PUT",
        body: data
      })
    }),
    getCustomerConnectLogsForInstallation: builder.query({
      query: (id) => ({
        url: `installations/${id}/customer_connect_logs`,
        method: "GET"
      })
    }),
    getPaymentsForInstallation: builder.query({
      query: (id) => ({
        url: `installations/${id}/payments`,
        method: "GET"
      })
    }),
    getRefundsForInstallation: builder.query({
      query: (id) => ({
        url: `installations/${id}/refunds`,
        method: "GET"
      })
    })
  })
});

export const {
  useGetInstallationsQuery,
  useLazyGetInstallationByIdQuery,
  useCreateInstallationMutation,
  useUpdateInstallationMutation,
  useCancelInstallationMutation,
  useOnHoldInstallationMutation,
  useDeleteInstallationMutation,
  useCreateCustomerConnectLogForInstallationMutation,
  useUpdateCustomerConnectLogForInstallationMutation,
  useGetCustomerConnectLogsForInstallationQuery,
  useGetPaymentsForInstallationQuery,
  useGetRefundsForInstallationQuery
} = installationApi;
